import React, { forwardRef, Ref, useState } from 'react';
import { buildClassName } from 'utils/build-class-name';
import TextInput from '@zoocasa/node-kit/components/controls/text-input';
import EyeOpenIcon from 'components/icon/eye-open-icon';
import EyeClosedIcon from 'components/icon/eye-closed-icon';
import styles from './style.module.scss';

import type { TextInputProps } from '@zoocasa/node-kit/components/controls/text-input';
import type { FieldError, FieldErrors, Merge } from 'react-hook-form';

type Props = TextInputProps & {
  label?: string;
  isHidden?: boolean;
  errors?: { message: string } | string | FieldError | Merge<FieldError, FieldErrors<any>>;
  autocomplete?: string;
  isCurrency?: boolean;
  containerClassName?: string;
  errorClassName?: string;
  testId?: string;
  labelInline?: boolean;
};

export default forwardRef((
  { label, isHidden, errors, containerClassName, className, autocomplete, type, isCurrency, testId, labelInline, errorClassName, ...inputProps }
  : Props, ref?: Ref<HTMLInputElement>) => {
  const componentClassName = buildClassName(styles.component, containerClassName, isHidden && styles.hidden, labelInline && styles['inline-label']);
  const inputClassName = buildClassName(className, errors && styles.error);
  const [isPasswordSeen, setIsPasswordSeen] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword && isPasswordSeen ? 'text' : type;

  return (
    <div className={componentClassName}>
      {label && <label className={buildClassName(labelInline && styles.inline)}>{label}</label>}
      <div className={buildClassName(styles['input-container'], isCurrency && styles['currency-icon'])}>
        <TextInput
          {...inputProps}
          type={inputType}
          className={inputClassName}
          ref={ref}
          autoComplete={autocomplete}
          data-testid={testId} />
        {isPassword && (
          <>
            {isPasswordSeen ?
              <EyeClosedIcon className={styles.eye} onClick={() => setIsPasswordSeen(!isPasswordSeen)} /> :
              <EyeOpenIcon className={styles.eye} onClick={() => setIsPasswordSeen(!isPasswordSeen)} />
            }
          </>
        )}
      </div>
      {typeof errors === 'object' &&
        <span className={buildClassName(styles['error-message'], label && !labelInline && styles['error-message-with-label'], errorClassName)}>
          {errors.message && 
          <>
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M5.5 7.5L4.5 7.5V6.5L5.5 6.5V7.5ZM5.5 5.5H4.5V2.5H5.5V5.5ZM5 10C7.76 10 10 7.76 10 5C10 2.24 7.76 0 5 0C2.24 0 0 2.24 0 5C0 7.76 2.24 10 5 10ZM5 1C7.205 1 9 2.795 9 5C9 7.205 7.205 9 5 9C2.795 9 1 7.205 1 5C1 2.795 2.795 1 5 1Z" fill="#D94A3A"/>
            </svg>
            <span style={{ marginLeft: 5 }}>
              {errors.message.toString()}
            </span>
          </>
          }
        </span>
      }
    </div>
  );
});
